export const isModeProduction = () => {
  const hostname = window.location.hostname.toLowerCase();
  if (hostname.startsWith('portal.truentity')) {
    return true;
  } else {
    return false;
  }
};
